import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ADMIN, PAYROLL } from 'components/RoleGate/constants';
// @ts-ignore
import { makeSelectPersonValue } from 'services/people/selectors';
import RoleButtonLink from 'components/RoleButtonLink';
import { AppState } from 'services/types';
import { Roles } from 'components/RoleGate/types';

import { PersonModal } from '../../../../../../constants';

interface OwnProps {
    personId: number;
}

interface ConnectedProps {
    email?: string;
}

type Props = ConnectedProps & OwnProps;

export class PersonDeleteLinkComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { email, personId } = this.props;

        let requiredRoles: Roles[] = [ADMIN, PAYROLL];

        if (email) {
            requiredRoles = [ADMIN];
        }

        return (
            <RoleButtonLink
                requiredRoles={requiredRoles}
                params={{
                    selectedPerson: personId,
                    [PersonModal.PERSON_DELETE_MODAL]: true
                }}
            >
                Delete
            </RoleButtonLink>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    email: makeSelectPersonValue('email')
});

export default connect(mapStateToProps)(PersonDeleteLinkComponent);
